import React from 'react';
import { connect } from 'react-redux';
import { MenuItemLink, WithPermissions, getResources, DashboardMenuItem } from 'react-admin';
import { withRouter } from 'react-router-dom';
import Divider from '@material-ui/core/Divider';
import ViewList from '@material-ui/icons/ViewList';
import PostIcon from '@material-ui/icons/Book';
import CommentIcon from '@material-ui/icons/ChatBubble';
import UserIcon from '@material-ui/icons/Group';
import TopicsIcon from '@material-ui/icons/ChromeReaderMode';
import PageIcon from '@material-ui/icons/Description';
import YoutubeIcon from '@material-ui/icons/VideoLibrary';
import SettingsApplications from '@material-ui/icons/SettingsApplications';
import { appOptions } from '../config/app';

const styles = {
  user: {
    color: '#000',
    textAlign: 'center',
    fontSize: '14px',
  },
};

const Menu = ({ onMenuClick, logout, ...props }) => {
  const userStorage = localStorage.getItem(appOptions.storageKey);
  if (!userStorage) {
    return logout;
  }
  const user = JSON.parse(userStorage);
  
  const ConfigLink = () => {
    const language = localStorage.getItem(appOptions.languageKey);
    let link = "/config/app/";
    switch (language) {
      case 'mk':
        link += 'grid.mk';
        break;
      case 'bg':
        link += 'topvesti.bg';
        break;
      case 'au':
        link += '1000.news';
        break;
      case 'mk2':
        link += 'vesti.mk';
        break;
      case 'rs':
        link += 'topvesti.rs';
        break;
      default:
        break;
    }
    return link;
  };

  return (
    <div>
      <p style={styles.user}> {user.firstName + ' ' + user.lastName} </p>
      <Divider />
      <DashboardMenuItem onClick={onMenuClick} />
      <WithPermissions>
        {({ permissions }) => permissions === 'admin'
            ? (<div>
        <MenuItemLink to="/mediasources" primaryText={'Media Sources'} leftIcon={<ViewList />} onClick={onMenuClick} />
        <MenuItemLink to="/mediatypes" primaryText={'Media Types'} leftIcon={<ViewList />} onClick={onMenuClick} />
        <MenuItemLink
          to="/articles/report"
          primaryText={'Articles Report'}
          leftIcon={<ViewList />}
          onClick={onMenuClick}
        />
        <MenuItemLink
          to="/articles/categories"
          primaryText={'Categories'}
          leftIcon={<ViewList />}
          onClick={onMenuClick}
        />
        <MenuItemLink to="/articles" primaryText={'Articles'} leftIcon={<PageIcon />} onClick={onMenuClick} />
        <MenuItemLink to="/topics" primaryText={'Topics'} leftIcon={<TopicsIcon />} onClick={onMenuClick} />
        <MenuItemLink to="/topics/report" primaryText={'Topics Stats'} leftIcon={<TopicsIcon />} onClick={onMenuClick} />
        <MenuItemLink to="/clustersadmin" primaryText={'Clusters'} leftIcon={<PostIcon />} onClick={onMenuClick} />
        <MenuItemLink to="/keywordweights" primaryText={'Keyword Weights'} leftIcon={<PostIcon />} onClick={onMenuClick} />
        <MenuItemLink
          to="/notifications"
          primaryText={'Notifications'}
          leftIcon={<CommentIcon />}
          onClick={onMenuClick}
        />
        <Divider />
        <MenuItemLink to="/tweets" primaryText={'Tweets'} leftIcon={<ViewList />} onClick={onMenuClick} />
        <MenuItemLink to="/twitterusers" primaryText={'Twitter Users'} leftIcon={<UserIcon />} onClick={onMenuClick} />
        <MenuItemLink to="/twitterusersnew" primaryText={'New Twitter Users'} leftIcon={<UserIcon />} onClick={onMenuClick} />
        <MenuItemLink to="/facebookpages" primaryText={'Facebook Pages'} leftIcon={<PageIcon />} onClick={onMenuClick} />
        <MenuItemLink
          to="/facebookposts"
          primaryText={'Facebook Posts'}
          leftIcon={<TopicsIcon />}
          onClick={onMenuClick}
        />
        <MenuItemLink to="/youtube" primaryText={'YouTube'} leftIcon={<YoutubeIcon />} onClick={onMenuClick} />
        <MenuItemLink to="/systemlogs" primaryText={'System Logs'} leftIcon={<PageIcon />} onClick={onMenuClick} />
        <MenuItemLink to="/users" primaryText={'Users'} leftIcon={<UserIcon />} onClick={onMenuClick} />
        <MenuItemLink to={ConfigLink()} primaryText={'Config'} leftIcon={<SettingsApplications />} onClick={onMenuClick} />
        <MenuItemLink
          to="/autopost/categories"
          primaryText={'Autopost categories'}
          leftIcon={<PageIcon />}
          onClick={onMenuClick}
        />
        {logout}
        </div>)
            : null
        }
      </WithPermissions>

      <WithPermissions>
        {({ permissions }) => permissions === 'app-admin'
            ? (<div>
        <MenuItemLink to="/mediasources" primaryText={'Media Sources'} leftIcon={<ViewList />} onClick={onMenuClick} />
        <MenuItemLink to="/mediatypes" primaryText={'Media Types'} leftIcon={<ViewList />} onClick={onMenuClick} />
        <MenuItemLink to="/articles/stats" primaryText={'Articles Stats'} leftIcon={<ViewList />} onClick={onMenuClick} />
        <MenuItemLink to="/articles" primaryText={'Articles'} leftIcon={<PageIcon />} onClick={onMenuClick} />
        <MenuItemLink to="/topics" primaryText={'Topics'} leftIcon={<TopicsIcon />} onClick={onMenuClick} />
        <MenuItemLink to="/topics/report" primaryText={'Topics Stats'} leftIcon={<TopicsIcon />} onClick={onMenuClick} />
        <MenuItemLink to="/clusterslight" primaryText={'Clusters'} leftIcon={<PostIcon />} onClick={onMenuClick} />
        <Divider />
        <MenuItemLink to="/tweets" primaryText={'Tweets'} leftIcon={<ViewList />} onClick={onMenuClick} />
        <MenuItemLink to="/twitterusers" primaryText={'Twitter Users'} leftIcon={<UserIcon />} onClick={onMenuClick} />
        <Divider />
        <MenuItemLink to="/facebookpages" primaryText={'Facebook Pages'} leftIcon={<PageIcon />} onClick={onMenuClick} />
        <MenuItemLink
          to="/facebookposts"
          primaryText={'Facebook Posts'}
          leftIcon={<TopicsIcon />}
          onClick={onMenuClick}
        />
        <Divider />
        <MenuItemLink to="/users" primaryText={'Users'} leftIcon={<UserIcon />} onClick={onMenuClick} />
        <Divider />
        {logout}
        </div>)
            : null
        }
      </WithPermissions>

      <WithPermissions>
      {({ permissions }) => permissions === 'app-manager'
            ? (<div>
        <MenuItemLink to="/mediasources" primaryText={'Media Sources'} leftIcon={<ViewList />} onClick={onMenuClick} />
        <MenuItemLink to="/mediatypes" primaryText={'Media Types'} leftIcon={<ViewList />} onClick={onMenuClick} />
        <MenuItemLink to="/articles/stats" primaryText={'Articles Stats'} leftIcon={<ViewList />} onClick={onMenuClick} />
        <MenuItemLink to="/articles" primaryText={'Articles'} leftIcon={<PageIcon />} onClick={onMenuClick} />
        <MenuItemLink to="/topics" primaryText={'Topics'} leftIcon={<TopicsIcon />} onClick={onMenuClick} />
        <MenuItemLink to="/topics/report" primaryText={'Topics Stats'} leftIcon={<TopicsIcon />} onClick={onMenuClick} />
        <MenuItemLink to="/clusterslight" primaryText={'Clusters'} leftIcon={<PostIcon />} onClick={onMenuClick} />
        <Divider />
        <MenuItemLink to="/tweets" primaryText={'Tweets'} leftIcon={<ViewList />} onClick={onMenuClick} />
        <MenuItemLink to="/twitterusers" primaryText={'Twitter Users'} leftIcon={<UserIcon />} onClick={onMenuClick} />
        <MenuItemLink to="/facebookpages" primaryText={'Facebook Pages'} leftIcon={<PageIcon />} onClick={onMenuClick} />
        <MenuItemLink
          to="/facebookposts"
          primaryText={'Facebook Posts'}
          leftIcon={<TopicsIcon />}
          onClick={onMenuClick}
        />
        {logout}
        </div>)
            : null
        }
      </WithPermissions>
    </div>
  );
};

const mapStateToProps = state => ({
    resources: getResources(state),
});

export default withRouter(connect(mapStateToProps)(Menu));



// WEBPACK FOOTER //
// ./src/resources/menu.js